import React, { useContext, useMemo } from "react";
import "./TimeTable.css";
import { translations } from "../../../../utils/lang";
import { Context } from "../../../../context/Context";

// getColor function
function getColor(value, maxValue) {
  const ratio = maxValue > 0 ? value / maxValue : 0;
  const start = [255, 255, 255];
  const end = [100, 70, 114];
  const r = Math.round(start[0] + (end[0] - start[0]) * ratio);
  const g = Math.round(start[1] + (end[1] - start[1]) * ratio);
  const b = Math.round(start[2] + (end[2] - start[2]) * ratio);
  return `rgb(${r}, ${g}, ${b})`;
}

// Determine if text should be white or black based on background color
function getContrastColor(rgb) {
  const [r, g, b] = rgb
    .replace(/^rgb\(|\s+|\)$/g, "")
    .split(",")
    .map(Number);
  // Perceived brightness formula
  const brightness = (r * 299 + g * 587 + b * 114) / 1000;
  return brightness < 150 ? "white" : "black";
}

export default function TimeTable({ details }) {
  const { lang } = useContext(Context);
  const hourCounts = useMemo(() => {
    const counts = Array(24).fill(0);
    details.forEach((item) => {
      const timeStr = item.time;
      if (!timeStr) return;
      const [hour] = timeStr.split(":").map(Number);
      if (!isNaN(hour) && hour >= 0 && hour <= 23) {
        counts[hour] += 1;
      }
    });
    return counts;
  }, [details]);

  const maxCount = Math.max(...hourCounts);

  // Split into two rows
  const firstRow = hourCounts.slice(0, 13); // 0–12
  const secondRow = hourCounts.slice(13, 24); // 13–23

  const renderRow = (row, startHour) => (
    <div className="time-row">
      {row.map((count, idx) => {
        const hour = startHour + idx;
        const color = getColor(count, maxCount);
        const fontColor = getContrastColor(color);
        const displayHour = `${hour.toString().padStart(2, "0")}:00`;

        return (
          <div key={hour} className="time-slot">
            <div
              className="circle"
              style={{ background: color, color: fontColor }}
              title={`${count} items`}
            >
              {count}
            </div>
            <div className="hour-label">{displayHour}</div>
          </div>
        );
      })}
    </div>
  );

  return (
    <div className="time-table-container">
      <h2>{translations[lang].Analysis.chartTitles[15]}</h2>
      {renderRow(firstRow, 0)}
      {renderRow(secondRow, 13)}
    </div>
  );
}
